import { Action, ActionType } from "@redux/actionTypes/apiActionType";
import { Reducer } from "react";

export interface IAPIState {
  apiDetailsByPID: IAPIDetailsByPID[];
}

export interface IAPIDetailsByPID {
  projectId: number;
  projectName: string;
  dosageForm: string;
  headers: Iheaders[];
  molecules: Record<string, any>[];
  batchSizesNumberofBatchSizes: ITableData;
  calculation: ITableData;
}
export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
  separator?: string;
}
export interface ITableData {
  headers: Iheaders[];
  tableData: Record<string, any>[];
}

const initialState = {
  apiDetailsByPID: [],
};

export const apiReducer: Reducer<IAPIState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.API_DETAILS_BY_PID:
      return {
        ...state,
        apiDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
